import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import viTranslation from './locales/vi.json';
import enTranslation from './locales/en.json';

const resources = {
    vi: {
        translation: viTranslation
    },
    en: {
        translation: enTranslation
    }
};

i18n
    // Phát hiện ngôn ngữ trình duyệt
    .use(LanguageDetector)
    // Tích hợp với React
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: {
            'vi': ['vi'],
            'en': ['vi'],
            'default': ['vi']
        },
        lng: 'vi', // Default language
        supportedLngs: ['vi', 'en'],
        interpolation: {
            escapeValue: false, // React đã xử lý XSS
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
            lookupQuerystring: 'lng',
            lookupCookie: 'i18next',
            lookupSessionStorage: 'i18nextLng',
            lookupFromPathIndex: 0,
            lookupFromSubdomainIndex: 0,
            excludeCacheFor: ['cimode'],
            htmlTag: document ? document.documentElement : undefined,
            convertDetectedLanguage: (lng) => {
                // Ensure only supported languages are used
                if (lng && ['vi', 'en'].includes(lng)) {
                    return lng;
                }
                return 'vi'; // Default to Vietnamese
            }
        }
    });

export default i18n; 